import type {BettingAdPromotionApiModel} from "./promotion/betting-ad.promotion.api-model";
import {BaseApiResponseModel} from "../../../infrastructure/models/base-api-response-model";
import type {BaseApiRequestModel} from "../../../infrastructure/models/base-api-request-model";
import type {BettingAdBookmakerApiModel} from "./bookmaker/betting-ad.bookmaker.api-model";
import {BettingAdBetBoostApiModel} from "./boost/betting-ad.bet-boost.api-model";

export class BettingAdResponseApiModel extends BaseApiResponseModel {
  promotions: Array<BettingAdPromotionApiModel>;
  betBoosts: Array<BettingAdBetBoostApiModel>;
  bookmakers: Array<BettingAdBookmakerApiModel>;

  constructor(model: BettingAdResponseApiModel, request: BaseApiRequestModel) {
    super(model, request);

    this.promotions = model?.promotions;
    this.betBoosts = model?.bet_boost;
    this.bookmakers = model?.bookmakers;
  }
}
